import React, { useState } from 'react';
import Table from 'partial/components/Table';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { useShowSubscriber } from 'modules/for-verification/hooks';
import Badges from 'modules/common/components/Badge';
import Pagination from 'partial/components/Pagination';
import { useOrgUpgradeHistory } from '../hooks';

function UpgradeHistory() {
  const { id } = useParams();
  const [, subscriber] = useShowSubscriber(id);
  const orgUuid = subscriber?.organization?.uuid;
  const [filter, setFilter] = useState({ page: 1 });
  const [isLoading, list, meta] = useOrgUpgradeHistory(filter, orgUuid);

  const format = [
    {
      label: 'current plan',
      key: (data) => <span>{data?.current_subscription?.name}</span>,
    },
    {
      label: 'requested plan',
      key: (data) => <span>{data?.requested_plan?.name}</span>,
    },
    {
      id: 'date',
      label: 'date',
      key: (data) => (
        <span>{dayjs(data?.date_requested).format('MMM DD, YYYY')}</span>
      ),
      contentClassName: 'whitespace-nowrap',
    },
    {
      label: 'remarks',
      key: 'remarks',
      contentClassName: 'w-[500px]',
    },
    {
      label: 'status',
      labelClassName: 'justify-end',
      contentClassName: 'flex justify-end',
      key: (data) => <Badges status={data?.status} />,
    },
  ];

  return (
    <div className="h-full flex flex-col space-y-10">
      <Table isLoading={isLoading} data={list} format={format} />
      <div className="px-3">
        <Pagination value={meta} onChange={setFilter} />
      </div>
    </div>
  );
}

export default UpgradeHistory;
